import { useState } from 'react';
import { GOAL_PERIODS, type GoalConfig, type GoalPeriod } from './raceGoals';

/** Panel de ajustes "Modo Objetivos": toggle + montos por período. Cubre el modal
 *  mientras está abierto; Guardar/Cancelar lo cierran. UI pura (sin lógica de carrera). */
export function RaceGoalsSettings({ initial, onSave, onCancel }: {
  initial: GoalConfig;
  onSave: (cfg: GoalConfig) => void;
  onCancel: () => void;
}) {
  const [enabled, setEnabled] = useState(initial.enabled);
  const [goals, setGoals] = useState<Record<GoalPeriod, number>>(initial.goals);

  return (
    <div className="absolute inset-0 z-50 flex flex-col overflow-auto rounded-2xl bg-white p-5 sm:p-6">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h3 className="text-lg font-black text-slate-800">Modo Objetivos</h3>
          <p className="text-xs text-slate-500">La carrera compara cada sucursal contra su meta (no contra el líder).</p>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={enabled}
          onClick={() => setEnabled((v) => !v)}
          className={`relative h-7 w-12 shrink-0 rounded-full transition-colors ${enabled ? 'bg-emerald-500' : 'bg-slate-300'}`}
        >
          <span className={`absolute top-0.5 h-6 w-6 rounded-full bg-white shadow transition-all ${enabled ? 'left-[22px]' : 'left-0.5'}`} />
        </button>
      </div>

      <div className="mt-5 grid gap-3 sm:grid-cols-2">
        {GOAL_PERIODS.map((p) => (
          <label key={p.key} className="flex flex-col gap-1 rounded-xl border border-slate-200 p-3 focus-within:border-slate-400">
            <span className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-wide text-slate-500">
              <span className="text-base">{p.icon}</span> {p.label}
            </span>
            <div className="flex items-center gap-1">
              <span className="font-bold text-slate-400">$</span>
              <input
                type="text"
                inputMode="numeric"
                value={goals[p.key] ? goals[p.key].toLocaleString('es-MX') : ''}
                onChange={(e) => setGoals((g) => ({ ...g, [p.key]: Number(e.target.value.replace(/\D/g, '')) || 0 }))}
                className="w-full bg-transparent text-lg font-black tabular-nums text-slate-800 outline-none"
              />
            </div>
          </label>
        ))}
      </div>

      <div className="mt-auto flex items-center justify-end gap-3 pt-6">
        <button type="button" onClick={onCancel} className="rounded-lg px-4 py-2 text-sm font-semibold text-slate-500 hover:bg-slate-100">
          Cancelar
        </button>
        <button
          type="button"
          onClick={() => onSave({ enabled, goals })}
          className="rounded-lg bg-[#9d1d1d] px-5 py-2 text-sm font-bold text-white hover:bg-[#7d1818]"
        >
          Guardar
        </button>
      </div>
    </div>
  );
}
